import React, { forwardRef } from 'react';
import MUIBackdrop, {
  BackdropProps as MUIBackdropProps,
} from '@material-ui/core/Backdrop';

interface BackdropProps extends MUIBackdropProps {}

const Backdrop = forwardRef<unknown, BackdropProps>((props, ref) => {
  return (
    <MUIBackdrop {...props} ref={ref}>
      {props.children}
    </MUIBackdrop>
  );
});

Backdrop.displayName = 'Backdrop';

export default Backdrop;
